import { Localization } from "../../../OW.Remoting/Remoting/Localization";
import { ElementUtils } from "../../UI.ElementarControls/Helpers/ElementUtils";
import { registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { MenuType } from "../Actions/MenuType";
import { IDropDownMenu, IDropDownMenuItemWithSubmenu } from "./DropDownInterfaces";
import { DropDownMenuItem } from "./DropDownMenuItem";

export class DropDownMenuWithSubmenuItem extends DropDownMenuItem implements IDropDownMenuItemWithSubmenu {
    private _submenu: IDropDownMenu;
    private _submenuElement: HTMLElement;
    private _openingtimeout: number;

    public isClickable: boolean = false;

    public get isEnabled(): boolean {
        return !this.classList.contains("disabled");
    }

    public set isEnabled(val: boolean) {
        this.classList.toggle("disabled", !val);
    }

    public override set locKey(v: string) {
        this._locKey = v;
        Localization.addLocData(this._captionElement, this._locKey);
    }

    public get submenu(): IDropDownMenu {
        return this._submenu;
    }

    public set submenu(val: IDropDownMenu) {
        this._submenu = val;

        // Nastaveni korenoveho menu
        if (this.parent) {
            if (this.parent.rootMenu)
                this._submenu.rootMenu = this.parent.rootMenu;
            else
                this._submenu.rootMenu = this.parent;
        }
        this.isEnabled = this.action ? this.action.enabledVisual : !!val;
    }

    public override set parent(val: IDropDownMenu) {
        this._parent = val;

        if (this.submenu) {
            if (this._parent.rootMenu)
                this._submenu.rootMenu = this._parent.rootMenu;
            else
                this._submenu.rootMenu = this._parent;
        }
    }

    public override get parent(): IDropDownMenu {
        return this._parent;
    }

    protected override _constructor(): void {
        super._constructor();

        this.visible = true;
    }

    protected override _createElement(): void {
        this.classList.add("DropDownMenuItem");
        if (!this.submenu)
            this.classList.add("disabled");

        this._textElement = document.createElement("div");
        this._textElement.classList.add("Text");

        this._createIconElement();
        this._createCaptionElement();

        if (this._locKey) {
            Localization.getTextPromise(this._locKey).then((locItem) => {
                this._captionElement.textContent = locItem;
            });
        }

        this.appendChild(this._iconElement);
        this.appendChild(this._textElement);
        this._textElement.appendChild(this._captionElement);
        this._textElement.appendChild(this._submenuElement);

        this._setListener();
    }

    protected override _createCaptionElement(): void {
        this._captionElement = document.createElement("div");
        this._captionElement.classList.add("Caption");
        this._submenuElement = document.createElement("div");
        this._submenuElement.classList.add("SubMenu");

        if (this._locKey) {
            Localization.getTextPromise(this._locKey).then((locItem) => {
                this._captionElement.textContent = locItem;
            });
        }
    }

    public static createDropSubMenuItem(icon: string, locKey: string, subMenu: IDropDownMenu, priority: number = 15, menuType?: MenuType): DropDownMenuWithSubmenuItem {
        const element = new DropDownMenuWithSubmenuItem();

        element.icon = icon;
        element.locKey = locKey;
        element.submenu = subMenu;
        element.priority = priority;
        if (menuType != null) {
            element.setAttribute("data-tomenu", MenuType[menuType]);
        }
        return element;
    }

    protected override _setListener(): void {
        const f_openSubmenu = () => {
            this.parent.openedSubmenu = this.submenu;

            this.submenu.show(this, null);
            this.submenu.lastSelectedItem = this;
            //this.Element.classList.add("selected");
        };

        const f_closeSubmenu = () => {
            if (this.parent.openedSubmenu) {
                //this.Element.classList.remove("selected");
                //logger.log(this.Parent.openedSubmenu);
                this.parent.openedSubmenu.close();
                this.parent.openedSubmenu = null;
            }
        };

        this.registerEventListener("click", (e: MouseEvent) => {
            if (e.button === 0) {
                if (this.parent.openedSubmenu == this.submenu)
                    return;
                if (this._openingtimeout)
                    clearTimeout(this._openingtimeout);
                e.stopImmediatePropagation();
                f_closeSubmenu();
                f_openSubmenu();
            }
        });

        this.registerEventListener("mouseenter", () => {
            if (!this.parent || !this.parent.openedSubmenu || this.parent.openedSubmenu.disableCloseTimeout)
                return;

            if (this.parent.openedSubmenu.closeTimeout)
                clearTimeout(this.parent.openedSubmenu.closeTimeout);
            if (this.parent.openedSubmenu == this.submenu)
                return;
            this._openingtimeout = self.setTimeout(() => {
                f_closeSubmenu();
                f_openSubmenu();
            }, 300);
        });

        this.registerEventListener("mouseleave", (e: MouseEvent) => {
            if (this._openingtimeout)
                clearTimeout(this._openingtimeout);

            if (this.parent.openedSubmenu) {
                if (this.parent.openedSubmenu.closeTimeout)
                    clearTimeout(this.parent.openedSubmenu.closeTimeout);
                if (ElementUtils.inElement(this.parent.openedSubmenu as any, e))
                    return;
                this.parent.openedSubmenu.closeTimeout = self.setTimeout(() => {
                    f_closeSubmenu();
                }, 300);
            }
        });
    }

    public override dispose(): void {
        super.dispose();
        this.submenu.dispose();
    }
}

registerCustomElement("tsc-DropDownMenuWithSubmenuItem", DropDownMenuWithSubmenuItem);
